import React from "react";
import "./card.css";

const Card = ({ emoji, heading, details, link }) => {
  return (
    <div className="card">
      <div className="card-head">
        <h4 className="card-heading">{heading}</h4>
        <div className="card-icon">
          <img src={emoji} alt="" />
        </div>
      </div>
      <span className="card-details">{details}</span>
      <a href={link} target="_blank" rel="noopener noreferrer">
        <button className="c-btn">Learn More</button>
      </a>
    </div>
  );
};

export default Card;
